import { Link, useLocation } from "@tanstack/react-router";
import { MessageCircle } from "lucide-react";

import { Container } from "../layout/Container";
import { ENQUIRY_EMAIL, enquiryMailto, enquiryWhatsapp } from "@/lib/enquiry";
import { STRAPLINE } from "@/lib/brand";

export function Footer() {
  // The WhatsApp message is chosen by the page the visitor is on, so their
  // first message arrives with context already in it.
  const { pathname } = useLocation();

  return (
    <footer className="bg-brand-blue-dark text-white">
      <Container className="flex flex-col items-center justify-between gap-6 py-8 text-center text-sm md:flex-row md:text-right">
        <div className="flex items-center gap-3 text-left">
          <img
            src="/LarasoftLogoPortraitWhiteWithClearBackground.svg"
            alt="Larasoft"
            width={40}
            height={40}
            className="h-10 w-auto"
          />
          <div>
            <div className="font-semibold">Larasoft</div>
            <div className="text-sm font-semibold text-brand-turquoise sm:text-base">
              {STRAPLINE}
            </div>
          </div>
        </div>
        <div className="space-y-1 text-slate-300">
          <div>
            <a href={enquiryMailto(pathname)} className="hover:underline">
              {ENQUIRY_EMAIL}
            </a>
          </div>
          <div className="flex justify-center md:justify-end">
            <a
              href={enquiryWhatsapp(pathname)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 font-medium text-white transition-colors hover:bg-white/20"
            >
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              Chat on WhatsApp
            </a>
          </div>
          <div className="flex flex-col gap-1 text-sm sm:flex-row sm:gap-3">
            <Link to="/pricing" className="hover:underline">
              Pricing
            </Link>
            <Link to="/legal/privacy" className="hover:underline">
              Privacy
            </Link>
            <Link to="/legal/paia" className="hover:underline">
              PAIA
            </Link>
            <Link to="/legal/data-processing" className="hover:underline">
              Data Processing
            </Link>
            <Link to="/legal/refund-policy" className="hover:underline">
              Refund Policy
            </Link>
            <Link to="/status" className="hover:underline">
              Status
            </Link>
          </div>
        </div>
      </Container>
    </footer>
  );
}
